/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { signUpPostRequestSchema } from './signUpPostRequestSchema.ts';
import { signUpPostResponseSchema } from './signUpPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postSignUp200Schema = z.lazy(() => signUpPostResponseSchema);

/**
 * @description 505 response
 */
export const postSignUp505Schema = z.any();

export const postSignUpMutationRequestSchema = z.lazy(() => signUpPostRequestSchema);

export const postSignUpMutationResponseSchema = z.lazy(() => postSignUp200Schema);
